export const TEMPLATE_SELECTION_STORAGE_KEY = "cvcanvas:selected-template-id";

function canUseStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function isTemplateIdAllowed(templateId, allowedTemplateIds = []) {
  if (!templateId) return false;
  if (!Array.isArray(allowedTemplateIds) || allowedTemplateIds.length === 0) {
    return true;
  }

  return allowedTemplateIds.includes(templateId);
}

export function readPersistedTemplateId() {
  if (!canUseStorage()) return null;

  try {
    return window.localStorage.getItem(TEMPLATE_SELECTION_STORAGE_KEY);
  } catch (error) {
    console.warn("[TemplateSelection] Failed to read localStorage template.", error);
    return null;
  }
}

export function writePersistedTemplateId(templateId) {
  if (!canUseStorage() || !templateId) return;

  try {
    window.localStorage.setItem(TEMPLATE_SELECTION_STORAGE_KEY, templateId);
  } catch (error) {
    console.warn("[TemplateSelection] Failed to persist localStorage template.", error);
  }
}

export function clearPersistedTemplateId() {
  if (!canUseStorage()) return;

  try {
    window.localStorage.removeItem(TEMPLATE_SELECTION_STORAGE_KEY);
  } catch (error) {
    console.warn("[TemplateSelection] Failed to clear localStorage template.", error);
  }
}

export function readTemplateIdFromSearch(search = "") {
  const params = new URLSearchParams(search || "");
  const templateId = params.get("template");
  return templateId || null;
}

export function withTemplateIdInSearch(search = "", templateId) {
  const params = new URLSearchParams(search || "");

  if (templateId) {
    params.set("template", templateId);
  } else {
    params.delete("template");
  }

  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : "";
}

export function resolveTemplateSelection({
  explicitTemplateId,
  currentTemplateId,
  persistedTemplateId,
  fallbackTemplateId,
  allowedTemplateIds = [],
}) {
  const candidates = [
    { templateId: explicitTemplateId, source: "route" },
    { templateId: currentTemplateId, source: "state" },
    { templateId: persistedTemplateId, source: "localStorage" },
    { templateId: fallbackTemplateId, source: "fallback" },
    { templateId: allowedTemplateIds[0], source: "allowed-default" },
  ];

  const resolvedCandidate =
    candidates.find((candidate) =>
      isTemplateIdAllowed(candidate.templateId, allowedTemplateIds),
    ) || null;

  return {
    templateId: resolvedCandidate?.templateId || null,
    source: resolvedCandidate?.source || "none",
  };
}

export function logTemplateSelection(scope, payload) {
  if (process.env.NODE_ENV === "production") return;
  // console.info(`[TemplateSelection][${scope}]`, payload);
}
